// Vendor
import { ElementRef } from '@angular/core';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Interfaces & constants
import { REPORT_BRANDING_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/core/urls.service";
import * as i3 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i4 from "@angular/common";
function AccountSettingsNavigationComponent_li_1_ul_3_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "a", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const child_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.activePage === child_r1.value);
    i0.ɵɵpropertyInterpolate("href", child_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", child_r1.label, " ");
} }
function AccountSettingsNavigationComponent_li_1_ul_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, AccountSettingsNavigationComponent_li_1_ul_3_li_1_Template, 3, 4, "li", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", tab_r3.children);
} }
function AccountSettingsNavigationComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2)(1, "a", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccountSettingsNavigationComponent_li_1_ul_3_Template, 2, 1, "ul", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isTabActive(tab_r3));
    i0.ɵɵproperty("href", tab_r3.children ? tab_r3.children[0].url : tab_r3.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r3.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r3.children == null ? null : tab_r3.children.length);
} }
export class AccountSettingsNavigationComponent {
    constructor(accountsService, eltRef, urlsService, featureService) {
        this.accountsService = accountsService;
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.featureService = featureService;
        this.NAVIGATION_TABS = [];
        this.activePage = '';
        this.activePage = this.eltRef.nativeElement.getAttribute('currentTab');
        const billingAdmin = this.eltRef.nativeElement.getAttribute('billingAdmin') === 'True';
        const hasBranding = this.featureService.userHasFeatures([REPORT_BRANDING_FEATURE]);
        this.accountsService.getClientGroupPreferences().subscribe(({ risk_score_methodology }) => {
            const hasDownsideCaptureRiskScoreMethodology = risk_score_methodology === 'DOWNSIDE_CAPTURE';
            this.NAVIGATION_TABS = [
                {
                    label: 'My Account',
                    value: 'account',
                    children: [
                        { label: 'Profile', value: 'basics', url: this.urlsService.ACCOUNTS.ACCOUNT_PROFILE },
                        ...(billingAdmin
                            ? [{ label: 'Billing', value: 'billing', url: this.urlsService.ACCOUNTS.BILLING_INFO }]
                            : []),
                        {
                            label: 'Communications',
                            value: 'communications',
                            url: this.urlsService.ACCOUNTS.PROFILE_COMMUNICATIONS,
                        },
                    ],
                },
                {
                    label: 'Data Settings',
                    value: 'data',
                    children: [
                        {
                            label: 'Data Sources',
                            value: 'data_sources',
                            url: this.urlsService.ACCOUNTS.DATA_SOURCES,
                        },
                        {
                            label: 'Quickflows',
                            value: 'quickflows',
                            url: this.urlsService.ACCOUNTS.QUICKFLOWS,
                        },
                        ...(hasDownsideCaptureRiskScoreMethodology
                            ? [
                                {
                                    label: 'Risk Score',
                                    value: 'risk_score',
                                    url: this.urlsService.ACCOUNTS.PROFILE_RISK_SCORE,
                                },
                            ]
                            : []),
                    ],
                },
                {
                    label: 'Integrations',
                    value: 'integrations',
                    url: this.urlsService.ACCOUNTS.INTEGRATIONS,
                },
                {
                    label: 'Share Groups',
                    value: 'share_groups',
                    url: this.urlsService.ACCOUNTS.SHARE_GROUPS_PAGE,
                },
                {
                    label: 'Report History',
                    value: 'report_history',
                    url: this.urlsService.ACCOUNTS.REPORT_HISTORY,
                },
                ...(hasBranding
                    ? [
                        {
                            label: 'Report Branding',
                            value: 'report_branding',
                            url: this.urlsService.ACCOUNTS.REPORT_DISPLAY_SETTINGS,
                        },
                    ]
                    : []),
            ];
        });
    }
    isTabActive(tab) {
        if (tab.children?.length) {
            return tab.children.some((child) => child.value === this.activePage);
        }
        return tab.value === this.activePage;
    }
}
AccountSettingsNavigationComponent.ɵfac = function AccountSettingsNavigationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountSettingsNavigationComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.UrlsService), i0.ɵɵdirectiveInject(i3.FeatureService)); };
AccountSettingsNavigationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountSettingsNavigationComponent, selectors: [["ycn-account-settings-navigation"]], standalone: false, decls: 2, vars: 1, consts: [[1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "nav-item"], [1, "nav-link", 3, "href"], [4, "ngIf"], [4, "ngFor", "ngForOf"]], template: function AccountSettingsNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵtemplate(1, AccountSettingsNavigationComponent_li_1_Template, 4, 5, "li", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.NAVIGATION_TABS);
    } }, dependencies: [i4.NgForOf, i4.NgIf], encapsulation: 2 });
